<template>
  <button
    :class="['mr10 mb5 bg-cl-transparent relative flex pointer color', isActive ? 'active' : '']"
    @click="$emit('change', variant)"
    :aria-label="$t('Select option ') + variant.label"
  >
    <span
      class="block color-inside"
      :class="{ 'active' : isActive }"
    />
    <span class="ml20 cl-black h5 uppercase color-label">
      {{ variant.label }}
    </span>
  </button>
</template>

<script>
import config from 'config'
import filterMixin from 'theme/mixins/filterMixin.ts'

export default {
  mixins: [filterMixin]
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/variables/colors';
  @import '~theme/css/helpers/functions/color';
  $color-active: color(primary);

  .color {
    height: 28px;
    border: none;
    width: 100%;
    outline: none;
    box-shadow: none;
    align-items: center;
  }

  .color-inside {
    width: 10px;
    height: 10px;
    outline-offset: 4px;
    outline: 2px solid $gray;

    &.active,
    &:hover {
      outline-color: $pink;
      background-color: $color-active;
    }
  }

  .color-label {
    margin-top: 2px;
  }

  .capitalize {
    text-transform: capitalize;
  }
</style>
